import { ReactNode } from 'react';
import cx from 'classnames';
import s from './TextBlock.module.scss';
import TextLoader from '@/shared/ui/TextLoader';

type TextBlockProps = {
  title?: string | ReactNode,
  value?: string | ReactNode,
  subValue?: string | ReactNode,
  size?: 'xl' | 'l',
  rootClassName?: string,
  isLoading?: boolean,
}

const TextBlock = (props: TextBlockProps) => {
  const {
    title,
    value,
    subValue,
    size = 'xl',
    rootClassName,
    isLoading = false,
  } = props;

  return (
    <div className={cx(s.root, rootClassName)}>
      {title ? 
        isLoading ? <TextLoader width="30px"/> : <div className={s.title}>{title}</div> 
      : null}
      <div>
        {isLoading ? <TextLoader width="60px"/> : (
          <>
            {value ? <span className={cx(s.value, s[size])}>{value}</span> : null} 
            {subValue ? <span className={s.subValue}>{subValue}</span> : null}
          </>
        )}
      </div>
    </div>
  );
}

export default TextBlock;
